<script>
import ScholarshipCompetitionApi from "../../scholarship/Services/Api/ScholarshipCompetitionApi";

const TheHeaderScholarshipCard = () => import("../Cards/ScholarshipCompetition/TheHeaderScholarshipCard.vue");
const TheMainCardSchCompetition = () => import("../Cards/ScholarshipCompetition/TheMainCardSchCompetition.vue");

import _ from "lodash";
export default {
  name: "TheScholarshipCompetitionTab",

  components: {
    TheHeaderScholarshipCard,
    TheMainCardSchCompetition,
  },

  data() {
    return {
      achievements: [],
      payloadCompetition: {
        prtf_achievement_type_id: null,
        selectedId: [],
        department_id: null,
      },
      selectedAchievements: [],
      snackbarSend: false,
      loadingListAchievements: false,
    }
  },

  async mounted() {
    await this.getAchievements();

    await this.findExistingStatement();
    if (!_.isEmpty(this.payloadCompetition.selectedId))  {
      this.arrayIdsToSelectAchievements();
    }
  },

  watch: {
    selectedAchievements() {
      this.selectAchievementsToArrayId();
    },
  },

  methods: {
    async getAchievements() {
      this.loadingListAchievements = true;

      const response = await ScholarshipCompetitionApi.getAvailableAchievementsChoose();
      if(_.isNil(response)) return;

      if (!response.data.hasOwnProperty("error")) {
        this.achievements = response.data.achievements;
      }

      this.loadingListAchievements = false;
    },

    selectAchievementsToArrayId() {
      this.payloadCompetition.selectedId = this.selectedAchievements.map((achievement) => achievement.id);
    },

    arrayIdsToSelectAchievements() {
      this.selectedAchievements =
        _.filter(this.achievements,
          (achievement) => _.includes(this.payloadCompetition.selectedId, achievement.id));
    },

    setAchievementType(achievementType) {
      this.payloadCompetition.prtf_achievement_type_id = achievementType;
    },

    setDepartment(department) {
      this.payloadCompetition.department_id = department;
    },

    setSelectedAchievements(selectedAchievement) {
      this.selectedAchievements = selectedAchievement;
    },

    async createCompetition() {
      const response = await ScholarshipCompetitionApi.create(this.payloadCompetition);
      if(_.isNil(response)) return;

      if (!response.data.hasOwnProperty("error")) {
        this.payloadCompetition = response.data.competition;
        this.snackbarSend = true;
      }
    },

    async updateCompetition() {
      const response = await ScholarshipCompetitionApi.update(this.payloadCompetition.id, this.payloadCompetition);
      if(_.isNil(response)) return;

      if (!response.data.hasOwnProperty("error")) {
        this.payloadCompetition = response.data.competition;
        this.snackbarSend = true;
      }
    },

    async findExistingStatement() {
      const response = await ScholarshipCompetitionApi.findExistingStatement();
      if(_.isNil(response)) return;

      if (response.data.hasOwnProperty("error")) {
        return;
      }

      if (!_.isNil(response.data.competition)) {
        return this.payloadCompetition = response.data.competition
      }
    },

    sendToServerMethod() {
      if (_.isNil(this.payloadCompetition?.id)) {
        return this.createCompetition();
      }
      else {
        return this.updateCompetition();
      }
    },

    async destroyScholarshipStatement() {
      const response = await ScholarshipCompetitionApi.destroy(this.payloadCompetition.id);
      if(_.isNil(response)) return;

      if (!response.data.hasOwnProperty("error")) {
        this.payloadCompetition = response.data.competition;
        this.arrayIdsToSelectAchievements();
      }
    }
  },


}
</script>

<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="5">
        <v-card
          elevation="0"
          outlined
          class="rounded-xl"
        >
          <the-header-scholarship-card
            @selectType="setAchievementType"
            @selectDepartment="setDepartment"
            :achievements="achievements"
            :selected-achievements="selectedAchievements"
            :selected-achievement-type="payloadCompetition.prtf_achievement_type_id"
            :payload-competition="payloadCompetition"
            :selected-department="payloadCompetition.department_id"
            @save="sendToServerMethod"
            @delete="destroyScholarshipStatement"
          />
        </v-card>
      </v-col>
      <v-col cols="12" md="7">
        <the-main-card-sch-competition
          @select="setSelectedAchievements"
          @refresh="getAchievements"
          :loading-list-achievements="loadingListAchievements"
          :selected-achievements="selectedAchievements"
          :achievements="achievements"/>
      </v-col>
    </v-row>

    <v-snackbar
      v-model="snackbarSend"
      :timeout="2000"
      color="teal darken-3"
      class="white--text text-center"
    >
      <v-icon small left>fa-check-circle</v-icon>Действие было успешно выполнено
    </v-snackbar>

  </v-container>
</template>

<style scoped>

</style>